import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
import moment from 'moment';
import {TagConfig, dateFormats, colorOptions, entities} from '../../util/uiconstants';
import {HttpStatusCodes} from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export function taskListReducer(state = initialState.taskList, action) {
	switch (action.type) {
		case types.GET_ALL_TASKS: {
			let allTasks = action.response.taskGroups ? action.response : {taskGroups: []};
			allTasks.apiLoaded = true;
			return {...allTasks, quickFilterId: action.quickFilterId};
		}
		case types.GET_ALL_TASKS_METRICS: {
			return action.response;
		}
		case types.UPDATE_TASKLIST_ON_DELETE_ASSIGNMENT: {
			let tempState = _.cloneDeep(state);
			let t = [];
			tempState.taskGroups.forEach((tg) => {
				tg.tasks.forEach((t) => {
					let filteredAssignments = t.assignments.filter(
						(a) =>
							!(
								a.assignmentId == action.data.assignmentId &&
								(a.assignedToRoleId == action.data.memberId || a.assignedtoUserId == action.data.memberId) &&
								(action.data.taskList == undefined ? true : action.data.taskList.includes(t.id))
							)
					);
					t.assignments = filteredAssignments;
				});
			});
			return tempState;
		}
		case types.DELETE_TASK_ON_REPLACE: {
			let tempState = _.cloneDeep(state);
			tempState.taskGroups.forEach((tg) => {
				tg.tasks.forEach((t) => {
					let filteredAssignments = t.assignments.filter(
						(a) =>
							!(
								a.assignmentId == action.data.assignmentId &&
								a.taskId == action.data.taskId &&
								(a.assignedToRoleId == action.data.memberId || a.assignedtoUserId == action.data.memberId)
							)
					);
					t.assignments = filteredAssignments;
				});
			});
			return tempState;
		}
		case types.DELETE_TASK_ON_REMOVE: {
			let tempState = _.cloneDeep(state);
			if (action.data) {
				tempState.taskGroups.forEach((tg) => {
					tg.tasks.forEach((t) => {
						let filteredAssignments = t.assignments.filter(
							(a) =>
								!(
									action.data.filter(
										(f) =>
											f.assignmentId === a.assignmentId &&
											f.taskId === a.taskId &&
											(a.assignedToRoleId == f.memberId || a.assignedtoUserId == f.memberId)
									).length > 0
								)
						);
						t.assignments = filteredAssignments;
					});
				});
			}

			return tempState;
		}
		case types.UPDATE_TASKLIST_ON_CREATE_ASSIGNMENT: {
			let tempState = _.cloneDeep(state);
			tempState.taskGroups.forEach((tg) => {
				tg.tasks.forEach((t) => {
					let tasksWithNewAssignments = action.data.filter((a) => a.taskId == t.id);
					if (tasksWithNewAssignments.length > 0) {
						tasksWithNewAssignments.forEach((a) => {
							t.assignments.push(a);
						});
					}
				});
			});
			return tempState;
		}
		case types.BULK_ASSOCIATE_TASK_TAG: {
			switch (action.payload.operation) {
				case 'Remove':
					let tempState = _.cloneDeep(state);
					tempState.taskGroups.forEach((tg) => {
						tg.tasks.forEach((t) => {
							if (action.meta.api.data.entitiesUIds.includes(t.id)) {
								let filteredTags = t.tagsList.filter((a) => a.engagementTagId !== action.meta.api.data.tagId);
								t.tagsList = filteredTags;
							}
						});
					});
					return tempState;
				default:
					return state;
			}
		}
		case types.UPDATE_BULK_TASK_TIME_PHASES: {
			if (action.response != null && action.response.taskIds != null && action.response.taskIds.length > 0) {
				let tempState = _.cloneDeep(state);
				tempState.taskGroups.forEach((tg) => {
					tg.tasks.forEach((t) => {
						let tasksWithNewTimePhases = action.response.taskIds.filter((a) => a == t.id);
						if (tasksWithNewTimePhases.length > 0) {
							tasksWithNewTimePhases.forEach((a) => {
								t.timephaseId = action.timePhaseId;
							});
						}
					});
				});
				return tempState;
			}
			return state;
		}
		case types.UPDATE_TASKLIST_ON_DELETE_TIME_PHASE: {
			let tempState = _.cloneDeep(state);
			tempState.taskGroups.forEach((tg) => {
				let filteredTimePhases = tg.tasks.filter((a) => a.timephaseId === action.data.timephaseId);
				if (filteredTimePhases.length > 0) {
					filteredTimePhases.forEach((a) => {
						a.timephaseId = null;
					});
				}
			});
			return tempState;
		}
		case types.UPDATE_TASKLIST_ON_EDIT_TAG: {
			let newState = _.cloneDeep(state);
			newState.taskGroups.forEach((tg) => {
				tg.tasks.forEach((t) => {
					let filteredTags = t.tagsList.filter((tg) => tg.engagementTagId === action.data.tagId);
					if (filteredTags.length > 0) {
						filteredTags.forEach((ftg) => {
							ftg.engagementTagName = action.data.tagName;
							ftg.colorCode = colorOptions[action.data.colorCode].value;
						});
					}
				});
			});
			return newState;
		}
		case types.UPDATE_TASKLIST_ON_DELETE_TAGS: {
			let newState = _.cloneDeep(state);
			newState.taskGroups.forEach((tg) => {
				tg.tasks.forEach((t) => {
					let filteredTags = t.tagsList.filter((tg) => tg.engagementTagId !== action.data.tagId);
					t.tagsList = filteredTags;
				});
			});
			return newState;
		}

		case types.UPDATE_COMPLETED_TASK: {
			//Updates the status of a given taskId with the new one of the task lists.tas
			if (action === undefined || !action.data || state?.taskGroups === undefined) return state;

			const {taskId, statusId, isEPEQRSignoffComplete, teamSummaryStatusId} = action.data;

			return (
				state.taskGroups && {
					...state,
					taskGroups: state.taskGroups.map((tg) => {
						return {
							...tg,
							tasks: tg.tasks.map((t) => {
								if (t.id === taskId) {
									return {
										...t,
										statusId: statusId,
										isEPEQRSignOffComplete: isEPEQRSignoffComplete,
										teamSummaryStatusId: teamSummaryStatusId ? teamSummaryStatusId : t.teamSummaryStatusId
									};
								} else {
									return t;
								}
							})
						};
					})
				}
			);
		}
		case types.CLEAR_TASK_LIST:
			return {};
		case types.RESET_TASK_LIST:
			return {
				availablePages: 0,
				categoryId: 0,
				engagementId: 0,
				forReviewCount: 0,
				subcategoryId: 0,
				taskAssertions: null,
				taskGroups: [],
				toPrepareCount: 0,
				totalCount: 0
			};
		// case types.SELECT_ENGAGEMENT_USERROLE_ITEM:
		// 	return {};
		case types.PUT_WCGW_TASK: {
			return updateHasWCGWAssociated(action, state, true) || state;
		}
		case types.DELETE_WCGW_TASK: {
			return updateHasWCGWAssociated(action, state, false) || state;
		}
		case types.UPDATE_DUE_DATE: {
			//Updates the due date of a given taskId with the new one of the task lists.
			if (action.payload === undefined) return state;

			let taskList = _.cloneDeep(state);
			taskList.taskGroups.forEach((tg) => {
				tg.tasks.forEach((task) => {
					if (
						action.payload.tasks.some((t) => {
							return t.id === task.id;
						})
					) {
						task.taskDueDate = calculateDueDate(
							action.payload.dueDate,
							action.payload.taskAssignments,
							action.payload.currentUserId,
							action.payload.dateFormat,
							task.id
						);
					}
				});
			});

			return _.cloneDeep(taskList);
		}
		case types.UPDATE_EP_EQR_SIGNOFF_INFO_TASK_LIST: {
			if (action === undefined) return state;

			let taskList = _.cloneDeep(state);
			taskList.taskGroups.forEach((tg) => {
				tg.tasks.forEach((t) => {
					if (t.id === action.data.taskId) {
						t.isEPSignoffRequired = action.data.isEPSignoffRequired;
						t.isEQRSignoffRequired = action.data.isEQRSignoffRequired;
						t.isEPSignoffUserRequired = action.data.isEPSignoffUserRequired;
						t.isEQRSignoffUserRequired = action.data.isEQRSignoffUserRequired;
					}
				});
			});

			return _.cloneDeep(taskList);
		}
		case types.UPDATE_ISBOOKMARK_INFO_TASK_LIST: {
			return (
				state.taskGroups && {
					...state,
					taskGroups: state.taskGroups.map((tg) => {
						return {
							...tg,
							tasks: tg.tasks.map((t) => {
								if (t.id === action.data.taskId) {
									return {
										...t,
										hasCurrentUserBookmarked: action.data.isBookmarked
									};
								} else {
									return t;
								}
							})
						};
					})
				}
			);
		}
		case types.APPLY_SIGNOFF_AND_CHANGE_TASK_STATUS: {
			return (
				state.taskGroups && {
					...state,
					taskGroups: state.taskGroups.map((tg) => {
						return {
							...tg,
							tasks: tg.tasks.map((t) => {
								if (action.meta.payload && t.id === action.meta.payload.id && t.hasCurrentUserBookmarked) {
									return {
										...t,
										hasCurrentUserBookmarked: false
									};
								} else {
									return t;
								}
							})
						};
					})
				}
			);
		}
		case types.UPDATE_NOTES_COUNT_TASK_LIST: {
			return (
				state.taskGroups && {
					...state,
					taskGroups: state.taskGroups.map((tg) => {
						return {
							...tg,
							tasks: tg.tasks.map((t) => {
								if (
									t.id === action.data.taskId &&
									(t.openTaskReviewCount != action.data.openTaskReviewCount ||
										t.openDocumentReviewNoteCountMyEng != action.data.openDocumentReviewNoteCount)
								) {
									return {
										...t,
										openTaskReviewCount:
											action.data.openTaskReviewCount != null ? action.data.openTaskReviewCount : t.openTaskReviewCount,
										openDocumentReviewNoteCountMyEng:
											action.data.openDocumentReviewNoteCount != null
												? action.data.openDocumentReviewNoteCount
												: t.openDocumentReviewNoteCountMyEng
									};
								} else {
									return t;
								}
							})
						};
					})
				}
			);
		}
		case types.GET_TASK_TAGS: {
			// get task tags for deep link task url
			if (!action.error && action.payload) {
				let resposnse = Utility.getSortedData(
					action.response?.data,
					TagConfig.groupByAttributeMapping,
					TagConfig.outputAttributesName
				);
				return (
					state.taskGroups && {
						...state,
						taskGroups: state.taskGroups.map((tg) => {
							return {
								...tg,
								tasks: tg.tasks.map((t) => {
									return {
										...t,
										tagsList: t.id == action.payload.taskId ? resposnse : t.tagsList
									};
								})
							};
						})
					}
				);
			}

			return state;
		}
		case types.ASSOCIATE_TASK_TAG: {
			if (state.taskGroups && !action.error) {
				if (action.payload.operation == 'Add') {
					return (
						state.taskGroups && {
							...state,
							taskGroups: state.taskGroups.map((tg) => {
								return {
									...tg,
									tasks: tg.tasks.map((t) => {
										return {
											...t,
											tagsList: action.payload.entitiesUIds.includes(t.id)
												? [...t.tagsList, buildTag(action.payload.tag, action.payload.tagGroup, t.id)]
												: t.tagsList
										};
									})
								};
							})
						}
					);
				}

				if (action.payload.operation == 'Remove') {
					return (
						state.taskGroups && {
							...state,
							taskGroups: state.taskGroups.map((tg) => {
								return {
									...tg,
									tasks: tg.tasks.map((t) => {
										return {
											...t,
											tagsList: action.payload.entitiesUIds.includes(t.id)
												? t.tagsList.filter((item) => {
														return item.engagementTagId != action.payload.tag.tagId;
												  })
												: t.tagsList
										};
									})
								};
							})
						}
					);
				}
			}

			return state;
		}
		case types.DISASSOCIATE_TASK_TAG: {
			if (!action.error) {
				return (
					state.taskGroups && {
						...state,
						taskGroups: state.taskGroups.map((tg) => {
							return {
								...tg,
								tasks: tg.tasks.map((t) => {
									return {
										...t,
										tagsList:
											t.id == action.payload.entityUId
												? t.tagsList.filter((item) => {
														return item.engagementTagId != action.payload.tag.tagId;
												  })
												: t.tagsList
									};
								})
							};
						})
					}
				);
			}

			return state;
		}
		case types.REMOVE_TASK_TAGS: {
			return (
				state.taskGroups && {
					...state,
					taskGroups: state.taskGroups.map((tg) => {
						return {
							...tg,
							tasks: tg.tasks.map((t) => {
								const filteredTagList = _.filter(t.tagsList, (tag) => {
									return !_.includes(action.removedTagIds, tag.engagementTagId);
								});
								if (_.size(filteredTagList) === _.size(t.tagsList)) {
									return t;
								}
								return {
									...t,
									tagsList: filteredTagList
								};
							})
						};
					})
				}
			);
		}
		case types.CLEAN_GET_ALL_TASKS:
			return {};
		case types.BULK_ADD_TAGS_TO_METADATA: {
			let data = action?.data;
			if (data && data.operation == 'Add') {
				return (
					state.taskGroups && {
						...state,
						taskGroups: state.taskGroups.map((tg) => {
							return {
								...tg,
								tasks: tg.tasks.map((t) => {
									return {
										...t,
										tagsList: data.taskIds.includes(t.id)
											? [...t.tagsList, buildTag(data.tag, data.tagGroup, t.id)]
											: t.tagsList
									};
								})
							};
						})
					}
				);
			}
			if (data && data.operation == 'Remove') {
				return (
					state.taskGroups && {
						...state,
						taskGroups: state.taskGroups.map((tg) => {
							return {
								...tg,
								tasks: tg.tasks.map((t) => {
									return {
										...t,
										tagsList: data.taskIds.includes(t.id)
											? t.tagsList.filter((item) => {
													return item.engagementTagId != data.tag.tagId;
											  })
											: t.tagsList
									};
								})
							};
						})
					}
				);
			}

			return state;
		}

		case types.UPDATE_BULK_REQUEST_TASK_RELATIONS: {
			if (action?.requests?.length && action.task) {
				let tempState = _.cloneDeep(state);
				tempState.taskGroups.forEach((tg) => {
					tg.tasks.forEach((t) => {
						if (t.id === action.task.id) {
							t.clientRequestsList = (t.clientRequestsList || []).concat(action.requests);
						}
					});
				});
				return tempState;
			}
			return state;
		}

		case types.DELETE_CLIENT_REQUEST_RELATED_TASK: {
			if (action?.responseObj?.status === HttpStatusCodes.NoContent) {
				let tempState = _.cloneDeep(state);
				tempState?.taskGroups?.forEach((tg) => {
					tg?.tasks?.forEach((t) => {
						if (t.id === action.meta?.relatedTaskId) {
							t.clientRequestsList = t.clientRequestsList.filter(
								(r) => r.clientRequestID !== action.meta?.clientRequestId
							);
						}
					});
				});
				return tempState;
			}
			return state;
		}
		default:
			return state;
	}
}

export function taskListReducerForWCGW(state = initialState.wcgwTasks, action) {
	switch (action.type) {
		case types.GET_ALL_TASKS_FOR_WCGW: {
			let allTasks = action.response.taskGroups ? action.response : {taskGroups: []};
			return {...allTasks};
		}
		default:
			return state;
	}
}

function updateHasWCGWAssociated(action, state, value) {
	if (
		state.taskAssertions &&
		state.taskAssertions.some((taskAssertion) => {
			return taskAssertion.taskId === action.meta.api.data.taskId;
		})
	) {
		let newState = _.cloneDeep(state);
		if (newState.taskAssertions) {
			var task = newState.taskAssertions.find((taskAssertion) => {
				return taskAssertion.taskId === action.meta.api.data.taskId;
			});

			if (task) {
				task.hasWCGWAssociated = value;

				return newState;
			}
		}
	}
}

export function taskListPreparerCountReducer(state = initialState.taskListPreparerCount, action) {
	switch (action.type) {
		case types.GET_ALL_TASKS_PREPARER_COUNT: {
			let allTasks = action.response.taskGroups ? action.response : {taskGroups: []};
			allTasks.apiLoaded = true;
			return {...allTasks};
		}
		case types.RESET_TASK_LIST:
			return {
				availablePages: 0,
				categoryId: 0,
				engagementId: 0,
				forReviewCount: 0,
				subcategoryId: 0,
				taskAssertions: null,
				taskGroups: [],
				toPrepareCount: 0,
				totalCount: 0
			};
		default:
			return state;
	}
}

export function buildtasksReducer(state = initialState.buildTasks, action) {
	switch (action.type) {
		case types.GET_ALL_BUILD_TASKS: {
			let allTasks = action.response.taskGroups ? action.response : {taskGroups: []};
			return {...allTasks};
		}
		default:
			return state;
	}
}

export function buildTag(tag, tagGroup, taskId) {
	let taskTag = {
		colorCode: tag.colorCode,
		engagementTagGroupId: tagGroup.groupId,
		engagementTagGroupName: tagGroup.groupName,
		engagementTagId: tag.tagId,
		engagementTagName: tag.tagName,
		entityCount: 0,
		entityUIID: taskId
	};

	return taskTag;
}

export function calculateDueDate(timePhaseDueDate, taskAssignments, userId, dateFormat, taskId) {
	let dueDays = timePhaseDueDate;
	if (
		taskAssignments &&
		taskAssignments.reviewersList &&
		_.some(taskAssignments.reviewersList, (ta) => ta.assignedToUserId === userId && ta.isComplete === false)
	) {
		let currentAssignment = _.find(
			taskAssignments.reviewersList,
			(ta) => ta.assignedToUserId === userId && ta.isComplete === false
		);
		let date = moment(Date.parse(timePhaseDueDate)).subtract(currentAssignment.dueDays, 'days');
		if (moment(date).isValid()) {
			const dateMoment = date.format(dateFormat && dateFormats[dateFormat] && dateFormats[dateFormat].label);
			return dateMoment;
		}
		return '';
	}

	return dueDays;
}

export function taskListUnassignedReducer(state = initialState.tasksUnassigned, action) {
	switch (action.type) {
		case types.GET_ALL_TASKS_UNASSIGNED: {
			return action.response;
		}
		case types.RESET_TASKS_UNASSIGNED: {
			return action.resetObj;
		}
		default:
			return state;
	}
}

export function taskRelatedUnrelatedEntitiesReducer(state = initialState.taskRelatedUnrelatedEntities, action) {
	switch (action.type) {
		case types.GET_ENTITY_TASKS: {
			if (action.data == entities.ItProcess)
				return {...state, itprocessRelatedTasks: {...state.itprocessRelatedTasks, ...action.response}};
			if (action.data == entities.Control)
				return {...state, controlRelatedTasks: {...state.controlRelatedTasks, ...action.response}};
			if (action.data == entities.SCOT)
				return {...state, scotRelatedTasks: {...state.scotRelatedTasks, ...action.response}};
			if (action.data == entities.ItControl)
				return {...state, itcontrolRelatedTasks: {...state.itcontrolRelatedTasks, ...action.response}};
		}
		case types.GET_UNRELATED_TASKS: {
			if (action.data == entities.ItProcess) {
				return {...state, itprocessUnrelatedTasks: {...state.itprocessUnrelatedTasks, ...action.response}};
			}
			if (action.data == entities.Control) {
				return {...state, controlUnrelatedTasks: {...state.controlUnrelatedTasks, ...action.response}};
			}
			if (action.data == entities.SCOT) {
				return {...state, scotUnrelatedTasks: {...state.scotUnrelatedTasks, ...action.response}};
			}
			if (action.data == entities.ItControl) {
				return {...state, itcontrolUnrelatedTasks: {...state.itcontrolUnrelatedTasks, ...action.response}};
			}
		}

		default:
			return state;
	}
}
